import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import {
  Question,
  ExerciseOptionTypes,
  ExerciseCategoryData,
  ExerciseGroupingsItem,
  ExerciseMatchingOptionsItem,
} from "@/types";
import GapFillExercise, {
  QuestionData,
} from "@/components/exercises/grammar/Desktop/GapFillExercise";
import GroupingExercise from "@/components/exercises/grammar/Desktop/GroupingExercise";
import GapFillExerciseMobile from "@/components/exercises/grammar/Mobile/GapFillExerciseMobile";
import GroupingExerciseMobile from "@/components/exercises/grammar/Mobile/GroupingExerciseMobile";
import MatchingOptionExercise from "@/components/exercises/grammar/Desktop/MatchingOptionExercise";
import MultipleChoiceExercise from "@/components/exercises/grammar/Desktop/MultipleChoiceExercise";
import MatchingOptionExerciseMobile from "@/components/exercises/grammar/Mobile/MatchingOptionExerciseMobile";
import MultipleChoiceExerciseMobile from "@/components/exercises/grammar/Mobile/MultipleChoiceExerciseMobile";

interface IProps {
  isSmall: boolean;
  exerciseData: ExerciseCategoryData[] | null;
  currentExerciseType: ExerciseOptionTypes;
}

const RenderExerciseComponent = ({
  isSmall,
  exerciseData,
  currentExerciseType,
}: IProps) => {
  if (!exerciseData) {
    return (
      <div className="mt-4 text-center">
        No data available for this exercise type.
      </div>
    );
  }

  switch (currentExerciseType) {
    case ExerciseOptionTypes.MultipleChoice:
    case ExerciseOptionTypes.TrueFalse:
      return isSmall ? (
        <MultipleChoiceExerciseMobile
          questions={exerciseData as unknown as Question[]}
          exerciseType={currentExerciseType}
        />
      ) : (
        <MultipleChoiceExercise
          questions={exerciseData as unknown as Question[]}
          exerciseType={currentExerciseType}
        />
      );
    case ExerciseOptionTypes.MatchingOption:
      return isSmall ? (
        <DndProvider
          backend={TouchBackend}
          options={{ enableMouseEvents: true }}
        >
          <MatchingOptionExerciseMobile
            data={exerciseData as ExerciseMatchingOptionsItem[]}
          />
        </DndProvider>
      ) : (
        <MatchingOptionExercise
          data={exerciseData as unknown as ExerciseMatchingOptionsItem[]}
        />
      );
    case ExerciseOptionTypes.GapFill:
      return isSmall ? (
        <GapFillExerciseMobile
          questions={exerciseData as unknown as QuestionData[]}
        />
      ) : (
        <GapFillExercise
          questions={exerciseData as unknown as QuestionData[]}
        />
      );
    case ExerciseOptionTypes.Grouping:
      if (
        exerciseData &&
        exerciseData.every(
          (item) => "id" in item && "category" in item && "word" in item,
        )
      ) {
        return isSmall ? (
          <GroupingExerciseMobile
            data={exerciseData as ExerciseGroupingsItem[]}
          />
        ) : (
          <GroupingExercise data={exerciseData as ExerciseGroupingsItem[]} />
        );
      } else {
        console.error("Invalid data format for Grouping exercise.");
        return <div>Invalid data format for exercise grouping.</div>;
      }
    default:
      return (
        <div className="mt-4 text-center">
          This exercise version is not found into platform.
        </div>
      );
  }
};

export default RenderExerciseComponent;
